"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HotkeyType = exports.ErrorCode = exports.VTubeStudioError = void 0;
var VTubeStudioError = (function (_super) {
    __extends(VTubeStudioError, _super);
    function VTubeStudioError(data, requestID, thrownBy) {
        var _newTarget = this.constructor;
        var _a;
        var _this = _super.call(this, data.message + " (Error Code: " + data.errorID + " " + ((_a = ErrorCode[data.errorID]) !== null && _a !== void 0 ? _a : ErrorCode.Unknown) + ") (Request ID: " + requestID + ")") || this;
        _this.data = data;
        _this.requestID = requestID;
        _this.thrownBy = thrownBy;
        _this.name = _this.constructor.name;
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return VTubeStudioError;
}(Error));
exports.VTubeStudioError = VTubeStudioError;
var ErrorCode;
(function (ErrorCode) {
    ErrorCode[ErrorCode["Unknown"] = NaN] = "Unknown";
    ErrorCode[ErrorCode["MessageBusError"] = -3] = "MessageBusError";
    ErrorCode[ErrorCode["MessageBusClosed"] = -2] = "MessageBusClosed";
    ErrorCode[ErrorCode["InternalClientError"] = -1] = "InternalClientError";
    ErrorCode[ErrorCode["InternalServerError"] = 0] = "InternalServerError";
    ErrorCode[ErrorCode["APIAccessDeactivated"] = 1] = "APIAccessDeactivated";
    ErrorCode[ErrorCode["JSONInvalid"] = 2] = "JSONInvalid";
    ErrorCode[ErrorCode["APINameInvalid"] = 3] = "APINameInvalid";
    ErrorCode[ErrorCode["APIVersionInvalid"] = 4] = "APIVersionInvalid";
    ErrorCode[ErrorCode["RequestIDInvalid"] = 5] = "RequestIDInvalid";
    ErrorCode[ErrorCode["RequestTypeMissingOrEmpty"] = 6] = "RequestTypeMissingOrEmpty";
    ErrorCode[ErrorCode["RequestTypeUnknown"] = 7] = "RequestTypeUnknown";
    ErrorCode[ErrorCode["RequestRequiresAuthetication"] = 8] = "RequestRequiresAuthetication";
    ErrorCode[ErrorCode["TokenRequestDenied"] = 50] = "TokenRequestDenied";
    ErrorCode[ErrorCode["TokenRequestCurrentlyOngoing"] = 51] = "TokenRequestCurrentlyOngoing";
    ErrorCode[ErrorCode["TokenRequestPluginNameInvalid"] = 52] = "TokenRequestPluginNameInvalid";
    ErrorCode[ErrorCode["TokenRequestDeveloperNameInvalid"] = 53] = "TokenRequestDeveloperNameInvalid";
    ErrorCode[ErrorCode["TokenRequestPluginIconInvalid"] = 54] = "TokenRequestPluginIconInvalid";
    ErrorCode[ErrorCode["AuthenticationTokenMissing"] = 100] = "AuthenticationTokenMissing";
    ErrorCode[ErrorCode["AuthenticationPluginNameMissing"] = 101] = "AuthenticationPluginNameMissing";
    ErrorCode[ErrorCode["AuthenticationPluginDeveloperMissing"] = 102] = "AuthenticationPluginDeveloperMissing";
    ErrorCode[ErrorCode["ModelIDMissing"] = 150] = "ModelIDMissing";
    ErrorCode[ErrorCode["ModelIDInvalid"] = 151] = "ModelIDInvalid";
    ErrorCode[ErrorCode["ModelIDNotFound"] = 152] = "ModelIDNotFound";
    ErrorCode[ErrorCode["ModelLoadCooldownNotOver"] = 153] = "ModelLoadCooldownNotOver";
    ErrorCode[ErrorCode["CannotCurrentlyChangeModel"] = 154] = "CannotCurrentlyChangeModel";
    ErrorCode[ErrorCode["HotkeyQueueFull"] = 200] = "HotkeyQueueFull";
    ErrorCode[ErrorCode["HotkeyExecutionFailedBecauseNoModelLoaded"] = 201] = "HotkeyExecutionFailedBecauseNoModelLoaded";
    ErrorCode[ErrorCode["HotkeyIDNotFoundInModel"] = 202] = "HotkeyIDNotFoundInModel";
    ErrorCode[ErrorCode["HotkeyCooldownNotOver"] = 203] = "HotkeyCooldownNotOver";
    ErrorCode[ErrorCode["HotkeyIDFoundButHotkeyDataInvalid"] = 204] = "HotkeyIDFoundButHotkeyDataInvalid";
    ErrorCode[ErrorCode["HotkeyExecutionFailedBecauseBadState"] = 205] = "HotkeyExecutionFailedBecauseBadState";
    ErrorCode[ErrorCode["HotkeyUnknownExecutionFailure"] = 206] = "HotkeyUnknownExecutionFailure";
    ErrorCode[ErrorCode["ColorTintRequestNoModelLoaded"] = 250] = "ColorTintRequestNoModelLoaded";
    ErrorCode[ErrorCode["ColorTintRequestMatchOrColorMissing"] = 251] = "ColorTintRequestMatchOrColorMissing";
    ErrorCode[ErrorCode["ColorTintRequestInvalidColorValue"] = 252] = "ColorTintRequestInvalidColorValue";
    ErrorCode[ErrorCode["MoveModelRequestNoModelLoaded"] = 300] = "MoveModelRequestNoModelLoaded";
    ErrorCode[ErrorCode["MoveModelRequestMissingFields"] = 301] = "MoveModelRequestMissingFields";
    ErrorCode[ErrorCode["MoveModelRequestValuesOutOfRange"] = 302] = "MoveModelRequestValuesOutOfRange";
    ErrorCode[ErrorCode["CustomParamNameInvalid"] = 350] = "CustomParamNameInvalid";
    ErrorCode[ErrorCode["CustomParamValuesInvalid"] = 351] = "CustomParamValuesInvalid";
    ErrorCode[ErrorCode["CustomParamAlreadyCreatedByOtherPlugin"] = 352] = "CustomParamAlreadyCreatedByOtherPlugin";
    ErrorCode[ErrorCode["CustomParamExplanationTooLong"] = 353] = "CustomParamExplanationTooLong";
    ErrorCode[ErrorCode["CustomParamDefaultParamNameNotAllowed"] = 354] = "CustomParamDefaultParamNameNotAllowed";
    ErrorCode[ErrorCode["CustomParamLimitPerPluginExceeded"] = 355] = "CustomParamLimitPerPluginExceeded";
    ErrorCode[ErrorCode["CustomParamLimitTotalExceeded"] = 356] = "CustomParamLimitTotalExceeded";
    ErrorCode[ErrorCode["CustomParamDeletionNameInvalid"] = 400] = "CustomParamDeletionNameInvalid";
    ErrorCode[ErrorCode["CustomParamDeletionNotFound"] = 401] = "CustomParamDeletionNotFound";
    ErrorCode[ErrorCode["CustomParamDeletionCreatedByOtherPlugin"] = 402] = "CustomParamDeletionCreatedByOtherPlugin";
    ErrorCode[ErrorCode["CustomParamDeletionCannotDeleteDefaultParam"] = 403] = "CustomParamDeletionCannotDeleteDefaultParam";
    ErrorCode[ErrorCode["InjectDataNoDataProvided"] = 450] = "InjectDataNoDataProvided";
    ErrorCode[ErrorCode["InjectDataValueInvalid"] = 451] = "InjectDataValueInvalid";
    ErrorCode[ErrorCode["InjectDataWeightInvalid"] = 452] = "InjectDataWeightInvalid";
    ErrorCode[ErrorCode["InjectDataParamNameNotFound"] = 453] = "InjectDataParamNameNotFound";
    ErrorCode[ErrorCode["InjectDataParamControlledByOtherPlugin"] = 454] = "InjectDataParamControlledByOtherPlugin";
    ErrorCode[ErrorCode["ParameterValueRequestParameterNotFound"] = 500] = "ParameterValueRequestParameterNotFound";
    ErrorCode[ErrorCode["NDIConfigCooldownNotOver"] = 550] = "NDIConfigCooldownNotOver";
    ErrorCode[ErrorCode["NDIConfigResolutionInvalid"] = 551] = "NDIConfigResolutionInvalid";
    ErrorCode[ErrorCode["ExpressionStateRequestInvalidFilename"] = 600] = "ExpressionStateRequestInvalidFilename";
    ErrorCode[ErrorCode["ExpressionStateRequestFileNotFound"] = 601] = "ExpressionStateRequestFileNotFound";
    ErrorCode[ErrorCode["ExpressionActivationRequestInvalidFilename"] = 650] = "ExpressionActivationRequestInvalidFilename";
    ErrorCode[ErrorCode["ExpressionActivationRequestFileNotFound"] = 651] = "ExpressionActivationRequestFileNotFound";
    ErrorCode[ErrorCode["ExpressionActivationRequestNoModelLoaded"] = 652] = "ExpressionActivationRequestNoModelLoaded";
    ErrorCode[ErrorCode["SetCurrentModelPhysicsRequestNoModelLoaded"] = 700] = "SetCurrentModelPhysicsRequestNoModelLoaded";
    ErrorCode[ErrorCode["SetCurrentModelPhysicsRequestModelHasNoPhysics"] = 701] = "SetCurrentModelPhysicsRequestModelHasNoPhysics";
    ErrorCode[ErrorCode["SetCurrentModelPhysicsRequestPhysicsControlledByOtherPlugin"] = 702] = "SetCurrentModelPhysicsRequestPhysicsControlledByOtherPlugin";
    ErrorCode[ErrorCode["SetCurrentModelPhysicsRequestNoOverridesProvided"] = 703] = "SetCurrentModelPhysicsRequestNoOverridesProvided";
    ErrorCode[ErrorCode["SetCurrentModelPhysicsRequestPhysicsGroupIDNotFound"] = 704] = "SetCurrentModelPhysicsRequestPhysicsGroupIDNotFound";
    ErrorCode[ErrorCode["SetCurrentModelPhysicsRequestNoOverrideValueProvided"] = 705] = "SetCurrentModelPhysicsRequestNoOverrideValueProvided";
    ErrorCode[ErrorCode["SetCurrentModelPhysicsRequestDuplicatePhysicsGroupID"] = 706] = "SetCurrentModelPhysicsRequestDuplicatePhysicsGroupID";
})(ErrorCode = exports.ErrorCode || (exports.ErrorCode = {}));
var HotkeyType;
(function (HotkeyType) {
    HotkeyType[HotkeyType["Unset"] = -1] = "Unset";
    HotkeyType[HotkeyType["TriggerAnimation"] = 0] = "TriggerAnimation";
    HotkeyType[HotkeyType["ChangeIdleAnimation"] = 1] = "ChangeIdleAnimation";
    HotkeyType[HotkeyType["ToggleExpression"] = 2] = "ToggleExpression";
    HotkeyType[HotkeyType["RemoveAllExpressions"] = 3] = "RemoveAllExpressions";
    HotkeyType[HotkeyType["MoveModel"] = 4] = "MoveModel";
    HotkeyType[HotkeyType["ChangeBackground"] = 5] = "ChangeBackground";
    HotkeyType[HotkeyType["ReloadMicrophone"] = 6] = "ReloadMicrophone";
    HotkeyType[HotkeyType["ReloadTextures"] = 7] = "ReloadTextures";
    HotkeyType[HotkeyType["CalibrateCam"] = 8] = "CalibrateCam";
    HotkeyType[HotkeyType["ChangeVTSModel"] = 9] = "ChangeVTSModel";
    HotkeyType[HotkeyType["TakeScreenshot"] = 10] = "TakeScreenshot";
    HotkeyType[HotkeyType["ScreenColorOverlay"] = 11] = "ScreenColorOverlay";
    HotkeyType[HotkeyType["RemoveAllItems"] = 12] = "RemoveAllItems";
    HotkeyType[HotkeyType["ToggleItemScene"] = 13] = "ToggleItemScene";
})(HotkeyType = exports.HotkeyType || (exports.HotkeyType = {}));
